import { SkuSearchResult } from '@emi/shared/models';
import { TimeSeriesDataRow } from './time-series-data-row';

export class TimeSeriesSku {
  constructor(
    public skuDetails: SkuSearchResult,
    public isReviewPending: boolean,
    public isChecked: boolean,
    public timeSeriesDataRows: TimeSeriesDataRow[]
  ) { }
}